import {post} from '@/utils/request';
import {erpserver} from '@/utils/baseUrl';

/*来料入库*/
//获取来料入库申请列表
export async function getEntrustCompanyHaveList(params) {
    return post(erpserver+'/currency/getEntrustCompanyHaveList', params, true)
}

//获取仓库
export async function getWarehouseList(params) {
    return post(erpserver+'/currency/getWarehouseList', params, true)
}
// 获取申请人
export async function getPersonList(params) {
    return post(erpserver+'/currency/getPersonList', params, true);
}
// 获取领用部门
export async function getGroupList(params) {
    return post(erpserver+'/currency/getGroupList', params, true);
}
// 获取公司
export async function getCompanyList(params) {
    return post(erpserver+'/currency/getCompanyList', params, true);
}
// 获取产品
export async function getEntrustOddNumHaveList(params) {
    return post(erpserver+'/currency/getEntrustOddNumHaveList', params, true);
}
// 获取委托单号
export async function getEntrustOddNumList(params) {
    return post(erpserver+'/currency/getEntrustOddNumList', params, true);
}
// 保存来料入库
export async function saveIncomingMaterial(params) {
    return post(erpserver+'/currency/saveIncomingMaterial', params, true);
}
//查看来料入库
export async function getIncomingMaterial(params) {
    return post(erpserver+'/currency/getIncomingMaterial', params, true);
}

/*产品产出*/
//获取产出列表
export async function getProduceList(params) {
    return post(erpserver+'/currency/getProduceList', params, true);
}

//获取消耗列表
export async function getConsumeList(params) {
    return post(erpserver+'/output/getConsumeList', params, true);
}
// 保存产出交付
export async function saveProduceOdd(params) {
    return post(erpserver+'/output/saveProduceOdd', params, true);
}
// 作废产出交付
export async function delProduceOdd(params) {
    return post(erpserver+'/output/delProduceOdd', params, true);
}
// 提交产出交付
export async function commitProduceOdd(params) {
    return post(erpserver+'/output/commitProduceOdd', params, true);
}
// 查看产出交付
export async function getProduceOdd(params) {
    return post(erpserver+'/output/getProduceOdd', params, true);
}

/*审核,交付*/
//获取指定列表
export async function getProduceOutList(params) {
    return post(erpserver+'/output/getProduceOutList', params, true);
}